import {combineEpics} from 'redux-observable';
import { AdobeAnalyticsEpic } from 'src/js/epics/AdobeAnalyticsEpic';
import {EpicCheckout} from './enrol/epics/EpicCheckout';
import {reduxFormEpics} from './epics/reduxFormEpics';
import {WebEpic} from './web/epics/WebEpic';
import {EpicCommon} from './common/epics/EpicCommon';
import {CommonAnalyticsEpic} from 'src/js/epics/CommonAnalyticsEpic';

export const EpicRoot = combineEpics(
  WebEpic,
  EpicCheckout,
  reduxFormEpics,
  CommonAnalyticsEpic,
  AdobeAnalyticsEpic,
  EpicCommon,
);
